// Background configuration per page and club level
// AI-generated images in public/assets/backgrounds/

export type PageId =
  | 'dashboard'
  | 'club'
  | 'facilities'
  | 'staff'
  | 'services'
  | 'economy'
  | 'competitions'
  | 'career'
  | 'settings'

interface PageTheme {
  name: string
  subtitle: string
  image: string
  // Gradient overlay tint (applied on top of image)
  overlayGradient: string
}

// Theme-aware veil defined in src/styles/tokens.css (dark veil / light veil)
const OVERLAY = 'var(--page-overlay)'

export const PAGE_THEMES: Record<PageId, PageTheme> = {
  dashboard: {
    name: 'Despacho del Director',
    subtitle: '',
    image: '/assets/backgrounds/dashboard.webp',
    overlayGradient: OVERLAY,
  },
  club: {
    name: 'Mi Club',
    subtitle: '',
    image: '/assets/campus/background/club.webp',
    overlayGradient: OVERLAY,
  },
  facilities: {
    name: 'Planos del Club',
    subtitle: '',
    image: '/assets/broadcast/facilities-night.webp',
    overlayGradient: OVERLAY,
  },
  staff: {
    name: 'Recursos Humanos',
    subtitle: '',
    image: '/assets/broadcast/staff-night.webp',
    overlayGradient: OVERLAY,
  },
  services: {
    name: 'Gestion Comercial',
    subtitle: '',
    image: '/assets/broadcast/services-night.webp',
    overlayGradient: OVERLAY,
  },
  economy: {
    name: 'Dpto. Financiero',
    subtitle: '',
    image: '/assets/broadcast/economy-night.webp',
    overlayGradient: OVERLAY,
  },
  competitions: {
    name: 'Competición',
    subtitle: '',
    image: '/assets/broadcast/competitions-night.webp',
    overlayGradient: OVERLAY,
  },
  career: {
    name: 'Carrera',
    subtitle: '',
    image: '/assets/broadcast/arena-dusk.webp',
    overlayGradient: OVERLAY,
  },
  settings: {
    name: 'Panel de Control',
    subtitle: 'Configuracion',
    image: '/assets/backgrounds/settings.webp',
    overlayGradient: OVERLAY,
  },
}

/**
 * Get the background config for a page.
 */
export function getPageBackground(pageId: PageId): { image: string; overlayGradient: string } {
  const theme = PAGE_THEMES[pageId]
  return { image: theme.image, overlayGradient: theme.overlayGradient }
}
